function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "mood-2",
  d: "M372.42,733.97c-6.19,0-12.4-.16-18.62-.48-94.7-4.86-181.83-46.31-245.35-116.7C44.93,546.39,12.62,455.47,17.48,360.77c4.86-94.7,46.31-181.83,116.7-245.35C204.58,51.9,295.51,19.59,390.2,24.45h0c94.7,4.86,181.83,46.31,245.35,116.7,63.52,70.4,95.83,161.32,90.97,256.01-4.86,94.7-46.31,181.83-116.7,245.36-65.77,59.35-149.45,91.45-237.39,91.45ZM371.81,60.95c-167.95,0-308.7,132.11-317.41,301.72-8.99,175.12,126.17,324.91,301.3,333.9,84.83,4.37,166.28-24.59,229.35-81.5,63.07-56.91,100.2-134.97,104.55-219.8,4.35-84.83-24.59-166.29-81.49-229.35-56.91-63.07-134.97-100.2-219.8-104.55-5.52-.28-11.03-.42-16.49-.42Z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "mood-2",
  cx: 224.64,
  cy: 374.33,
  r: 41.77
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "mood-2",
  cx: 519.36,
  cy: 374.33,
  r: 41.77
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "mood-2",
  d: "M255.95,545.74c-2.92,0-5.87-.79-8.53-2.43-7.63-4.72-9.99-14.73-5.27-22.36,1.64-2.64,40.96-64.75,121.79-69.42,56.29-3.26,111.25,23.06,140.01,67.02,4.91,7.51,2.81,17.58-4.7,22.49-7.51,4.91-17.58,2.81-22.49-4.7-22.51-34.41-66.07-54.96-110.95-52.37-64.15,3.71-94.76,52.03-96.03,54.08-3.07,4.97-8.39,7.7-13.83,7.7Z"
});

var SvgMood2 = function SvgMood2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 750 750",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMood2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mood2.9bc92a1a.svg";
export { ForwardRef as ReactComponent };